var render = function render(){
  var _vm$banner;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.banner ? _c('div', {
    class: `main-visual main-visual-${_vm.random}`
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._l(((_vm$banner = _vm.banner) === null || _vm$banner === void 0 ? void 0 : _vm$banner.slides) || [], function (slide, index) {
    return [_c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('v-card', {
      staticClass: "main-visual__inner",
      attrs: {
        "to": slide !== null && slide !== void 0 && slide.isOuterLink ? undefined : slide === null || slide === void 0 ? void 0 : slide.url,
        "href": slide !== null && slide !== void 0 && slide.isOuterLink ? slide === null || slide === void 0 ? void 0 : slide.url : undefined,
        "target": slide === null || slide === void 0 ? void 0 : slide.target,
        "flat": "",
        "tile": ""
      }
    }, [_c('div', {
      staticClass: "main-visual__img",
      style: 'background-image:url(' + (slide === null || slide === void 0 ? void 0 : slide.image) + ');'
    })])], 1)];
  })], 2), _vm._m(0)])]) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "swiper-control"
  }, [_c('button', {
    staticClass: "swiper-prev"
  }, [_c('i', {
    staticClass: "icon icon-left-arrow-circle"
  })]), _c('button', {
    staticClass: "swiper-next"
  }, [_c('i', {
    staticClass: "icon icon-right-arrow-circle"
  })])]);

}]

export { render, staticRenderFns }